import { Route, Routes, BrowserRouter, Navigate } from "react-router-dom";
import { useEffect } from "react";
import "./App.css";
import "./components/Updates.css";
import LoginForm from "./components/Login";
import SignupForm from "./components/Signup";
import Home from "./components/Home";
import AuthLanding from "./components/AuthLanding";
import BookDetails from "./components/BookDetails";
import BookReprocessStatus from "./components/BookReprocessStatus";
import SelectedBook from "./components/SelectedBook";
import BookList from "./components/BookList";
import BookForm from "./components/BookForm";
import CourseBookMapping from "./components/CourseBookMapping";
import NewUpdates from "./components/NewUpdates";
import NewCoupon from "./components/NewCoupon";
import BooksContent from "./components/BooksContent";
import BookFiles from "./components/BookFiles";
import DBdata from "./components/DBdata";
import BannerView from "./components/BannerManagement/BannerView";
import RolesAdmin from "./components/admin/RolesAdmin";
import UiPermissionsAdmin from "./components/admin/UiPermissionsAdmin";
import PasswordManagement from "./components/admin/PasswordManagement";
import UserManagement from "./components/admin/UserManagement";
import AdminDashboard from "./components/admin/AdminDashboard";
import AdminNavigation from "./components/admin/AdminNavigation";
import ProtectedRoute from "./components/access/ProtectedRoute";
import ApiManagement from "./components/admin/ApiManagement";
import CodeValuesAdmin from "./components/admin/CodeValuesAdmin";
import { loadPermissions } from "./permissions";
import FaqTable from "./components/FAQ/FaqTable";
import TestimonialTable from "./components/Testimonials/TestimonialTable";
import { AuthProvider, useAuth } from "./components/access/AuthContext";
import Notification from "./components/Notification";
import Sidebar from "./components/Sidebar";
import { Box, CircularProgress } from "@mui/material";
import SubscriptionTable from "./components/Subscriptions/SubscriptionTable";
import AllUsers from "./components/Users/AllUsers";
import Users from "./components/Users/Users";
import MessageTable from "./components/MessageTable";
import MasterClassView from "./components/MasterClass/MasterClassView";
import ChatRoom from "./components/ChatRoom";
import SalesReports from "./components/SalesDashboard/SalesReports";
import CollegeMangement from "./components/Colleges/CollegeMangement";
import College_coures from "./components/Colleges/College_coures";
import Academics from "./components/Academics/Academics";
import Mentorship from "./components/Mentorship/Mentorship";
import Assessment from "./components/Assessments/Assessment";
import AssessmentTestForm from "./components/Assessments/AssessmentTestForm";
import AssessmentStudentPerformance from "./components/Assessments/AssessmentStudentPerformance";
import Banners from "./components/BannerManagement/Banners";
import Notifyme from "./components/NotifyMe/Notifyme";
import ViewBannerCoursesMap from "./components/BannerManagement/ViewBannerCoursesMap";
import ViewAdvertisementsMap from "./components/BannerManagement/ViewAdvertisementsMap";
import ViewPopUpMap from "./components/BannerManagement/ViewPopUpMap";
import ViewCourseCollegeMap from "./components/Academics/ViewCourseCollegeMap";
import MentorAnalytics from "./components/Mentorship/MentorAnalytics";
import MentorSubjects from "./components/Mentorship/MentorSubjects";
import ComboDiscount from "./components/ComboDiscount/ComboDiscount";
import CampaignLinks from "./components/CampaignLinks/CampaignLinks";
import CampaignLinkForm from "./components/CampaignLinks/CampaignLinkForm";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
function AppRoutes() {
  const { token } = useAuth();

  const isLoggedIn = !!token || !!localStorage.getItem("token");
  useEffect(() => {
    loadPermissions({ preferServerEvaluation: true }).catch(() => {});
  }, []);
  return (
    <div className="App">
      <Routes>
        <Route
          path="/"
          element={
            isLoggedIn ? (
              <Navigate
                to={localStorage.getItem("lastVisited") || "/booklist"}
                replace
              />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route path="/login" element={<Home />} />
        <Route path="/auth-landing" element={<AuthLanding />} />
        <Route path="/signup" element={<SignupForm />} />

        <Route element={<Sidebar />}>
          <Route
            path="/booklist"
            element={
              <ProtectedRoute
                componentKey="ROUTE_BOOKLIST"
                element={<BookList />}
              />
            }
          />
          <Route
            path="/bookdetails"
            element={
              <ProtectedRoute
                componentKey="ROUTE_BOOKDETAILS"
                element={<BookDetails />}
              />
            }
          />
          <Route
            path="/bookform"
            element={
              <ProtectedRoute
                componentKey="ROUTE_BOOKFORM"
                element={<BookForm />}
              />
            }
          />
          <Route
            path="/reprocess-status"
            element={
              <ProtectedRoute
                componentKey="ROUTE_BOOKDETAILS"
                element={<BookReprocessStatus />}
              />
            }
          />
          <Route
            path="/selectedbook/:id"
            element={
              <ProtectedRoute
                componentKey="ROUTE_SELECTEDBOOK"
                element={<SelectedBook />}
              />
            }
          />
          <Route
            path="/courseBookMapping"
            element={
              <ProtectedRoute
                componentKey="ROUTE_COURSE_BOOK_MAPPING"
                element={<CourseBookMapping />}
              />
            }
          />
          <Route
            path="/updates"
            element={
              <ProtectedRoute
                componentKey="ROUTE_UPDATES"
                element={<NewUpdates />}
              />
            }
          />
          <Route
            path="/Coupons"
            element={
              <ProtectedRoute
                componentKey="ROUTE_COUPONS"
                element={<NewCoupon />}
              />
            }
          />
          <Route
            path="/dbdata"
            element={
              <ProtectedRoute
                componentKey="ROUTE_DB_DATA"
                element={<DBdata />}
              />
            }
          />
          <Route
            path="/notification"
            element={
              <ProtectedRoute
                componentKey="ROUTE_DB_DATA"
                element={<Notifyme />}
              />
            }
          />
          <Route
            path="/messages"
            element={
              <ProtectedRoute
                componentKey="ROUTE_DB_DATA"
                element={<MessageTable />}
              />
            }
          />
          <Route
            path="/Users"
            element={
              <ProtectedRoute componentKey="ROUTE_USERS" element={<Users />} />
            }
          />
          <Route
            path="/ChatRoom"
            element={<ProtectedRoute element={<ChatRoom />} />}
          />
          <Route
            path="/Subscriptions"
            element={<ProtectedRoute element={<SubscriptionTable />} />}
          />
          <Route
            path="/BannerManagement"
            element={<ProtectedRoute element={<Banners />} />}
          />
          <Route
            path="/FaqManagement"
            element={<ProtectedRoute element={<FaqTable />} />}
          />
          <Route
            path="/TestimonialManagement"
            element={<ProtectedRoute element={<TestimonialTable />} />}
          />
          <Route
            path="/masterClasses"
            element={<ProtectedRoute element={<MasterClassView />} />}
          />
          <Route
            path="/SalesDashboard"
            element={<ProtectedRoute element={<SalesReports />} />}
          />
          <Route
            path="/academics"
            element={<ProtectedRoute element={<Academics />} />}
          />
          <Route
            path="/mentorship"
            element={<ProtectedRoute element={<Mentorship />} />}
          />
          <Route
            path="/comboDiscount"
            element={<ProtectedRoute element={<ComboDiscount />} />}
          />
          <Route
            path="/campaign-links"
            element={<ProtectedRoute element={<CampaignLinks />} />}
          />
          <Route
            path="/campaign-links/new"
            element={<ProtectedRoute element={<CampaignLinkForm />} />}
          />
          <Route
            path="/campaign-links/:id/edit"
            element={<ProtectedRoute element={<CampaignLinkForm />} />}
          />
          <Route
            path="/assessment"
            element={<ProtectedRoute element={<Assessment />} />}
          />
          <Route
            path="/assessment/tests/new"
            element={<ProtectedRoute element={<AssessmentTestForm />} />}
          />
          <Route
            path="/assessment/tests/:testId/edit"
            element={<ProtectedRoute element={<AssessmentTestForm />} />}
          />
          <Route
            path="/assessment/students/:studentId/performance"
            element={<ProtectedRoute element={<AssessmentStudentPerformance />} />}
          />
          <Route
            path="/mentorship/analytics"
            element={<ProtectedRoute element={<MentorAnalytics />} />}
          />
          <Route
            path="/mentorship/subjects"
            element={<ProtectedRoute element={<MentorSubjects />} />}
          />
          <Route
            path="/college_courses"
            element={<ProtectedRoute element={<College_coures />} />}
          />
          <Route
            path="/banner-course-mapping"
            element={<ProtectedRoute element={<ViewBannerCoursesMap />} />}
          />
          <Route
            path="/advertisement-course-mapping"
            element={<ProtectedRoute element={<ViewAdvertisementsMap />} />}
          />
          <Route
            path="/pop-up-course-mapping"
            element={<ProtectedRoute element={<ViewPopUpMap />} />}
          />
          <Route
            path="/CourseCollegeMap"
            element={<ProtectedRoute element={<ViewCourseCollegeMap />} />}
          />
        </Route>
        <Route
          path="/booksContent"
          element={
            <ProtectedRoute
              componentKey="ROUTE_BOOKSCONTENT"
              element={<BooksContent />}
            />
          }
        />
        <Route
          path="/booksfiles"
          element={
            <ProtectedRoute
              componentKey="ROUTE_BOOKSFILES"
              element={<BookFiles />}
            />
          }
        />

        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute
              componentKey="ADMIN_ROLES_PAGE"
              element={
                <AdminNavigation>
                  <AdminDashboard />
                </AdminNavigation>
              }
            />
          }
        />
        <Route
          path="/admin/users"
          element={
            <ProtectedRoute
              componentKey="ADMIN_ROLES_PAGE"
              element={
                <AdminNavigation>
                  <UserManagement />
                </AdminNavigation>
              }
            />
          }
        />
        <Route
          path="/admin/roles"
          element={
            <ProtectedRoute
              componentKey="ADMIN_ROLES_PAGE"
              element={
                <AdminNavigation>
                  <RolesAdmin />
                </AdminNavigation>
              }
            />
          }
        />
        <Route
          path="/admin/ui-permissions"
          element={
            <ProtectedRoute
              componentKey="ADMIN_UI_PERMISSIONS_PAGE"
              element={
                <AdminNavigation>
                  <UiPermissionsAdmin />
                </AdminNavigation>
              }
            />
          }
        />
        <Route
          path="/admin/passwords"
          element={
            <ProtectedRoute
              componentKey="ADMIN_PASSWORDS_PAGE"
              element={
                <AdminNavigation>
                  <PasswordManagement />
                </AdminNavigation>
              }
            />
          }
        />
        <Route
          path="/admin/api-management"
          element={
            <ProtectedRoute
              componentKey="ADMIN_API_MANAGEMENT_PAGE"
              element={
                <AdminNavigation>
                  <ApiManagement />
                </AdminNavigation>
              }
            />
          }
        />
        <Route
          path="/admin/code-values"
          element={
            <ProtectedRoute
              componentKey="ADMIN_CODE_VALUES_PAGE"
              element={
                <AdminNavigation>
                  <CodeValuesAdmin />
                </AdminNavigation>
              }
            />
          }
        />
      </Routes>
    </div>
  );
}

export default App;
